import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { createGlobalStyle } from 'styled-components'
import CommonImage from '@components/common/CommonImage'
import CommonText from '@components/common/CommonText'
import CommonButton from '@components/common/CommonButton'
import { useHistory, useParams } from 'react-router'
import { useUserContext } from '@hooks/useUserContext'
import { userApi, followApi, postApi } from '@api/api'

const UserPage = props => {
  const { state, handleGetUser } = useUserContext()
  const { userId } = useParams()
  const history = useHistory()
  if (!state.user) {
    return <div>404</div>
  }

  const { _id, image, fullName, followers, following, posts } = state.user

  const createFollow = async () => {
    await followApi.createFollow(userId)
    await handleGetUser()

    const { resData } = await userApi.getUserInfo(userId)

    setUserInfo({
      isOtherUser: true,
      _id: resData._id,
      username: resData.username,
      fullName: resData.fullName,
      image: resData.image,
      followers: resData.followers,
      following: resData.following,
      posts: resData.posts,
    })
  }
  const [userInfo, setUserInfo] = useState({
    isOtherUser: false,
    _id: '',
    username: '',
    fullName: '',
    image: null,
    followers: [],
    following: [],
    posts: [],
  })

  useEffect(async () => {
    const isOriginUser = !!(!userId || userId === _id)
    const id = isOriginUser ? _id : userId
    const postRes = await postApi.getUserPostList(id)

    if (!isOriginUser) {
      const { resData } = await userApi.getUserInfo(id)
      const { _id, fullName, image, followers, following } = resData
      setUserInfo({
        isOtherUser: true,
        _id,
        fullName,
        image,
        followers,
        following,
        posts: postRes.resData,
      })
    } else {
      setUserInfo({
        isOtherUser: false,
        _id,
        fullName,
        image,
        followers,
        following,
        posts: postRes.resData,
      })
    }
  }, [userId])

  const userActivities = [
    {
      id: 'recipe',
      text: '레시피',
      value: userInfo.posts.length,
    },
    {
      id: 'follower',
      text: '팔로워',
      value: userInfo.followers.length,
    },
    {
      id: 'following',
      text: '팔로잉',
      value: userInfo.following.length,
    },
  ]

  return (
    <>
      <UserPageStyle />
      <div className="metaInfo-wrapper">
        <div className="activity-wrapper">
          <CommonImage
            width={135}
            height={135}
            style={
              userInfo.image
                ? { borderRadius: '100%' }
                : { borderRadius: '100%', border: '3px solid #FFA34B' }
            }
            src={userInfo.image || require('../assets/images/404.png').default}
          />
          <div className="user-activity">
            {userActivities.map(userActivity => (
              <div
                className={`activity-item active-${userActivity.id}`}
                key={userActivity.id}>
                <CommonText fontWeight={700} fontSize={30} tag="p">
                  {userActivity.value}
                </CommonText>
                <CommonText fontSize={26} tag="p" style={{ marginTop: '5px' }}>
                  {userActivity.text}
                </CommonText>
              </div>
            ))}
          </div>
        </div>
        <div className="user-intro">
          <CommonText fontWeight={700} fontSize={20} tag="p">
            {userInfo.fullName}
          </CommonText>
        </div>
        {userInfo.isOtherUser ? (
          <CommonButton
            text="팔로우"
            width="100%"
            style={{ marginTop: '20px' }}
            onClick={createFollow}
          />
        ) : (
          <CommonButton
            link="/userinfo"
            text="비밀번호 변경"
            width="100%"
            backgroundColor="#ffffff"
            color="#FFA34B"
            style={{ marginTop: '20px' }}
          />
        )}
      </div>
      <div className="post-wrapper">
        {userInfo.posts.map(post => (
          <CommonImage
            key={post._id}
            className="post-item"
            height={200}
            src={post.image || require('../assets/images/404.png').default}
            style={{ cursor: 'pointer' }}
            onClick={() => history.push(`/post/detail/${post._id}`)}
          />
        ))}
      </div>
    </>
  )
}

UserPage.propTypes = {}

const UserPageStyle = createGlobalStyle`
header {
  padding: 0 30px;
}
.container {
  padding-left: 0;
  padding-right: 0;
}

.metaInfo-wrapper{
  margin: 50px 40px 0 40px;
  padding: 0 30px;
}
.activity-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.user-activity {
  display: flex;
}
.activity-item {
  text-align: center;

  &:not(:last-child) {
    margin-right: 40px;
  }
}

.user-intro {
  margin-top: 30px;
}
.post-wrapper{
  display: flex;
  flex-wrap: wrap;
  margin-top: 40px;
}
.post-item{
  width: calc((100% / 3))
}
.post-item:first-child {
    width: calc((100% / 3) + 0.02px)
  }
.post-item:nth-child(4n) {
    width: calc((100% / 3) + 0.02px)
  }
`

export default UserPage
